import Vue from 'vue';
import store from '@/features/registration/store';
import vuetify from '@/plugins/vuetify';
import PageRegistration from '@/features/registration/pages/page-registration';
import '@/plugins/assets';
import '@/plugins/vuelidate';
import '@/plugins/vue-notification';
import '@/plugins/vue-scroll-to';
import '@/assets/scss/index.scss';

Vue.config.productionTip = false;

/**
 * Unirise registration widget
 */
(element => {
  if (element) {
    new Vue({
      store,
      vuetify,
      render: h => h(PageRegistration),
    }).$mount(element);
  }
})(document.getElementById('unr-registration'));
